import { ApiSchedulingRepository } from 'repository/api-scheduling-repository'
import { ApiResponse } from 'service/protocols/api-scheduling/api-scheduling-client'
import {
  IApiSchedulingRepository,
  RepositoryRequest
} from 'service/protocols/api-scheduling/api-scheduling-repository'
import { GetStorage } from 'service/protocols/cache/get-storage'
import { getEnv } from 'infra/config/env'

export class PrepareApiRequestSchedulingDecorator
  implements IApiSchedulingRepository
{
  constructor(
    private readonly getStorage: GetStorage,
    private readonly apiSchedulingRepository: ApiSchedulingRepository
  ) {}

  async post(data: RepositoryRequest): Promise<ApiResponse> {
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/scheduling${data.url}`
        : `${getEnv('REACT_APP_API_MATERDEI_SCHEDULING_URL') + data.url}`

    return await this.apiSchedulingRepository.post(data)
  }
}
